import React from 'react';
import { FadeIn } from './FadeIn';
import { Minus } from 'lucide-react';
export const Experts = () => {
  const criteria = [{
    title: 'Опыт 15+ лет с позвоночником',
    desc: 'Не «по диплому», а в реальной практике — сотни сложных случаев в год.'
  }, {
    title: 'Работа в ТОП-клиниках Москвы',
    desc: 'Бурденко, ЦИТО, НМИЦ им. Пирогова и аналогичный уровень. Не районная поликлиника.'
  }, {
    title: 'Научная и преподавательская активность',
    desc: 'Публикации в рецензируемых журналах, преподавание в ведущих медвузах.'
  }, {
    title: 'Высокий рейтинг на ПроДокторов',
    desc: 'Сотни отзывов от реальных пациентов и оценка не ниже 4.8 — публичная репутация, которую невозможно подделать.'
  }];
  const removed = [{
    title: 'Убрали поток',
    desc: 'Эксперт разбирает ваш случай в удобное для себя время — без очереди следующих пациентов за дверью и звонков от регистратуры.'
  }, {
    title: 'Убрали интерес к операции',
    desc: 'Фиксированный гонорар, не зависит от вывода. Эксперт не работает в клинике, куда вы обращаетесь.'
  }, {
    title: 'Убрали спешку',
    desc: '48 часов на тщательный анализ вместо разговора в коридоре между приёмами.'
  }, {
    title: 'Убрали односторонность',
    desc: 'Двое экспертов смотрят независимо, не видят выводы друг друга. Перекрёстная проверка встроена в процесс.'
  }];
  const funnelStages = [{
    num: '200+',
    label: 'рассматриваем'
  }, {
    num: '~50',
    label: 'первичный отбор'
  }, {
    num: '~30',
    label: 'углублённое интервью'
  }, {
    num: 'ТОП-20',
    label: 'в активном пуле',
    highlight: true
  }];
  return <section className="py-24 bg-white" data-id="element-45">
      <div className="max-w-6xl mx-auto px-6" data-id="element-46">
        {/* Section header */}
        <FadeIn data-id="element-47">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-48">
            <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase text-sage mb-4" data-id="element-49">
              Эксперты
            </span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-navy mb-6 leading-[1.1]" data-id="element-50">
              ТОП-20 врачей Москвы по позвоночнику. Без интереса к операции и
              спешки.
            </h2>
            <p className="text-lg text-navyLight leading-relaxed" data-id="element-51">
              Объективный разбор от тех, кто ежедневно принимает решения в самых
              сложных случаях.
            </p>
          </div>
        </FadeIn>

        {/* Selection block — funnel + criteria */}
        <FadeIn delay={0.1} data-id="element-52">
          <div className="bg-beigeLight rounded-3xl p-8 md:p-12 mb-20" data-id="element-53">
            <div className="text-center mb-10" data-id="element-54">
              <h3 className="font-serif text-2xl md:text-3xl text-navy" data-id="element-55">
                Как мы отбираем экспертов
              </h3>
            </div>

            {/* Criteria 2x2 */}
            <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-56">
              {criteria.map((c, i) => <div key={i} className="bg-white rounded-2xl p-6 flex gap-4 border border-beige/60" data-id="element-57">
                  <div className="w-8 h-8 rounded-full bg-sage text-white flex items-center justify-center font-serif text-sm shrink-0 mt-0.5" data-id="element-58">
                    {i + 1}
                  </div>
                  <div data-id="element-59">
                    <h4 className="font-medium text-navy mb-1.5" data-id="element-60">{c.title}</h4>
                    <p className="text-sm text-navyLight leading-relaxed" data-id="element-61">
                      {c.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Big thesis quote */}
        <FadeIn delay={0.15} data-id="element-62">
          <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-63">
            <div className="font-serif text-7xl md:text-8xl text-sage/30 leading-none mb-2 select-none" data-id="element-64">
              "
            </div>
            <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl text-navy italic leading-[1.15] mb-6" data-id="element-65">
              Мы убрали всё, что мешает врачу быть честным
            </h3>
            <p className="text-navyLight text-lg max-w-2xl mx-auto" data-id="element-66">
              В обычной клинике на врача давит система. Мы вынесли его из этой
              системы — чтобы вы получили мнение, а не отписку.
            </p>
          </div>
        </FadeIn>

        {/* What we removed — 2x2 grid */}
        <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-67">
          {removed.map((item, i) => <FadeIn key={i} delay={0.05 * i} data-id="element-68">
              <div className="bg-white border border-beige rounded-2xl p-7 h-full hover:shadow-soft transition-shadow duration-300" data-id="element-69">
                <div className="flex items-center gap-3 mb-3" data-id="element-70">
                  <div className="w-9 h-9 rounded-full bg-sage/15 flex items-center justify-center shrink-0" data-id="element-71">
                    <Minus size={18} className="text-sage" strokeWidth={2.5} data-id="element-72" />
                  </div>
                  <h4 className="font-medium text-navy text-lg" data-id="element-73">
                    {item.title}
                  </h4>
                </div>
                <p className="text-navyLight text-sm leading-relaxed pl-12" data-id="element-74">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* Closing reassurance */}
        <FadeIn delay={0.3} data-id="element-75">
          <p className="text-center font-serif italic text-lg md:text-xl text-navyLight max-w-3xl mx-auto mt-16 leading-relaxed" data-id="element-76">
            Это не просто «ещё одно мнение». Это разбор уровня врачебной
            комиссии в федеральном центре — но без бюрократии и за 48 часов.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-77">
          <p className="text-center text-xs text-navyLight/60 italic mt-6" data-id="element-78">
            * Полные ФИО, регалии и места работы экспертов указываются в
            итоговом отчёте.
          </p>
        </FadeIn>
      </div>
    </section>;
};